import type { SolutionDetail } from "@/types/detail";
import { solutionsA } from "@/data/solutionDetails.a";
import { solutionsB } from "@/data/solutionDetails.b";

/** All dedicated solution pages, in display order. */
export const solutionDetails: SolutionDetail[] = [...solutionsA, ...solutionsB];

const bySlug = new Map(solutionDetails.map((s) => [s.slug, s]));

export function getSolutionDetail(slug?: string): SolutionDetail | undefined {
  return slug ? bySlug.get(slug) : undefined;
}
